const TOKEN_KEY = 'tt-kiosk-deviceToken';
const COMPANY_ID_KEY = 'tt-kiosk-companyId';
const COMPANY_NAME_KEY = 'tt-kiosk-companyName';
const OFFICE_ID_KEY = 'tt-kiosk-officeId';
const OFFICE_LABEL_KEY = 'tt-kiosk-officeLabel';

export interface KioskSession {
  deviceToken: string;
  companyId: string;
  companyName: string;
  officeId: number;
  officeLabel: string;
}

export function loadKioskSession(): KioskSession | null {
  const deviceToken = window.localStorage.getItem(TOKEN_KEY);
  const companyId = window.localStorage.getItem(COMPANY_ID_KEY);
  const officeIdRaw = window.localStorage.getItem(OFFICE_ID_KEY);
  if (!deviceToken || !companyId || !officeIdRaw) return null;
  const officeId = Number(officeIdRaw);
  if (Number.isNaN(officeId)) return null;
  return {
    deviceToken,
    companyId,
    companyName: window.localStorage.getItem(COMPANY_NAME_KEY) ?? '',
    officeId,
    officeLabel: window.localStorage.getItem(OFFICE_LABEL_KEY) ?? '',
  };
}

export function saveKioskSession(session: KioskSession): void {
  window.localStorage.setItem(TOKEN_KEY, session.deviceToken);
  window.localStorage.setItem(COMPANY_ID_KEY, session.companyId);
  window.localStorage.setItem(COMPANY_NAME_KEY, session.companyName);
  window.localStorage.setItem(OFFICE_ID_KEY, String(session.officeId));
  window.localStorage.setItem(OFFICE_LABEL_KEY, session.officeLabel);
}

export function clearKioskSession(): void {
  window.localStorage.removeItem(TOKEN_KEY);
  window.localStorage.removeItem(COMPANY_ID_KEY);
  window.localStorage.removeItem(COMPANY_NAME_KEY);
  window.localStorage.removeItem(OFFICE_ID_KEY);
  window.localStorage.removeItem(OFFICE_LABEL_KEY);
}

export function getKioskToken(): string | null {
  return window.localStorage.getItem(TOKEN_KEY);
}
